import * as React from 'react'

import { Button } from '@factorialco/deprecated-design-system'

import { observer } from 'mobx-react'

import { useNavigation } from 'modules/core/hooks/useNavigation'
import hasFeature from 'modules/core/lib/hasFeature'
import i18n from 'modules/core/lib/i18n'

import { Status } from 'modules/ats/lib/enums'
import JobBoardCard from 'modules/ats/pages/JobPostingPromotion/JobBoards/JobBoardCard'

import LinkedinLogo from './linkedin-logo.svg'

export const LinkedinLimitedListings = observer(() => {
  const { navigation } = useNavigation()

  const integrationInstalled = hasFeature('linkedin_limited_listings')
  const status = integrationInstalled ? Status.Linked : undefined
  const action = (
    <Button.Router
      to={navigation.discover.marketplace.fullPath()}
      rel="nofollow noopener noreferrer"
      type="secondary"
      iconName="settings"
      blankTarget
    >
      {i18n.t('ats.job_details.promotion.job_boards.buttons.set_up_button')}
    </Button.Router>
  )

  return (
    <JobBoardCard
      title="LinkedIn Limited Listings"
      description={i18n.t('ats.job_details.promotion.linkedin_limited_listings.description')}
      logo={LinkedinLogo}
      action={!integrationInstalled && action}
      status={status}
      isFree
    />
  )
})
